export default __webpack_public_path__ + "static/media/retirement-sum-scheme-tablet.14b04abd.svg";